/**
 * cardStyles.js - the one card look every Dashboard widget shares (10/12/26):
 * white, 12px corners, a hairline border and a whisper of shadow. A `fill`
 * card takes the whole widget (the customizable grid sizes it) and scrolls
 * its own list inside, so nothing is cut by the widget's rounded corners.
 */
export const CARD_RADIUS = 12;

export const FILL_CARD = {
  height: '100%',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
  background: '#fff',
  borderRadius: CARD_RADIUS,
  border: '1px solid #ECECEC',
  boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
  overflow: 'hidden',
};

/** The small uppercase title at the top of a fill card. */
export const FILL_LABEL = {
  fontSize: 10,
  fontWeight: 700,
  color: '#5A5A5A',
  letterSpacing: 1.5,
  textTransform: 'uppercase',
  padding: '14px 16px 10px',
  flexShrink: 0,
};

/** The part of a fill card that scrolls (its list). */
export const FILL_SCROLL = { flex: 1, minHeight: 0, overflowY: 'auto' };
